module.exports = "<div>\r\n    <form [formGroup]=\"form\">\r\n   \r\n      <div *ngFor=\"let question of questions\" class=\"form-row\">\r\n        <app-question [question]=\"question\" [form]=\"form\"></app-question>\r\n      </div>\r\n    </form>\r\n  </div>"


//////////////////
// WEBPACK FOOTER
// C:/Users/AINSA WEB/Documents/proyects/ROUTEMEE/routemee-web-application/src/app/components/dynamic-form/dynamic-form.component.html
// module id = ../../../../../src/app/components/dynamic-form/dynamic-form.component.html
// module chunks = main